
export default function SystemCardHeaderDivider() {
    // Used in ResultsScreen cards to slice card header from content

    // BUILD
    return (
        <div className={`w-full h-[1px] min-h-[1px] bg-greyLight5 mt-[8px]`}>
        </div>
    );
}